import { useMemo } from 'react'

import { MenuConfig } from 'src/apollo/sites'

import { useRestaurant } from 'shared/components/common/restaurant_context/RestaurantContext'

import { overrideConfigBasedOnTemplate } from 'public/components/default_template/menu_section/menuStylingOverrides'
import { DEFAULT_COLORS } from 'public/components/default_template/meta/StyleMeta'
import { useThemeColorScheme } from 'public/components/default_template/meta/useTheme'

export const useStyledCardColors = () => {
  const {
    restaurant: { config }
  } = useRestaurant()
  const getColorFromTheme = useThemeColorScheme()

  const templateOverrides = useMemo(
    () => overrideConfigBasedOnTemplate(config.ooConfig as MenuConfig, config),
    [config]
  )

  const [backgroundColor, textColor, borderColor] = getColorFromTheme(
    (theme) => [
      theme.colorOverrides?.onlineOrderingMenu?.cardBackground ??
        theme.colorScheme.surface.secondary,
      theme.colorOverrides?.onlineOrderingMenu?.itemTitle ??
        theme.colorScheme.text.default,
      theme.colorOverrides?.onlineOrderingMenu?.cardBorder ??
        theme.colorScheme.border.default
    ],
    [
      config.ooConfig?.colors?.background ??
        DEFAULT_COLORS.background ??
        '#FFFFFF',
      config.ooConfig?.colors?.primaryText ?? DEFAULT_COLORS.text,
      templateOverrides?.borderColor
    ]
  )

  return { backgroundColor, textColor, borderColor, templateOverrides }
}
